module.exports = __webpack_public_path__ + "img/hometop.1e88da46.png";